export default __webpack_public_path__ + "static/media/ag-icon.a0114173.svg";